const actions = {
  ADD_BEGIN: 'ADD_BEGIN',
  ADD_SUCCESS: 'ADD_SUCCESS',
  ADD_ERR: 'ADD_ERR',

  READ_BEGIN: 'READ_BEGIN',
  READ_SUCCESS: 'READ_SUCCESS',
  READ_ERR: 'READ_ERR',

  UPDATE_BEGIN: 'UPDATE_BEGIN',
  UPDATE_SUCCESS: 'UPDATE_SUCCESS',
  UPDATE_ERR: 'UPDATE_ERR',

  DELETE_BEGIN: 'DELETE_BEGIN',
  DELETE_SUCCESS: 'DELETE_SUCCESS',
  DELETE_ERR: 'DELETE_ERR',

  SINGLE_DATA_BEGIN: 'SINGLE_DATA_BEGIN',
  SINGLE_DATA_SUCCESS: 'SINGLE_DATA_SUCCESS',
  SINGLE_DATA_ERR: 'SINGLE_DATA_ERR',

  UPLOAD_BEGIN: 'UPLOAD_BEGIN',
  UPLOAD_SUCCESS: 'UPLOAD_SUCCESS',
  UPLOAD_ERR: 'UPLOAD_ERR',

  UploadBegin: () => {
    return {
      type: actions.UPLOAD_BEGIN,
    };
  },

  UploadSuccess: (data) => {
    return {
      type: actions.UPLOAD_SUCCESS,
      data,
    };
  },

  UploadErr: (err) => {
    return {
      type: actions.UPLOAD_ERR,
      err,
    };
  },

  AddBegin: () => {
    return {
      type: actions.ADD_BEGIN,
    };
  },

  AddSuccess: (data) => {
    return {
      type: actions.ADD_SUCCESS,
      data,
    };
  },

  AddErr: (err) => {
    return {
      type: actions.ADD_ERR,
      err,
    };
  },

  ReadBegin: () => {
    return {
      type: actions.READ_BEGIN,
    };
  },

  ReadSuccess: (data) => {
    return {
      type: actions.READ_SUCCESS,
      data,
    };
  },

  ReadErr: (err) => {
    return {
      type: actions.READ_ERR,
      err,
    };
  },

  UpdateBegin: () => {
    return {
      type: actions.UPDATE_BEGIN,
    };
  },

  UpdateSuccess: (data) => {
    return {
      type: actions.UPDATE_SUCCESS,
      data,
    };
  },

  UpdateErr: (err) => {
    return {
      type: actions.UPDATE_ERR,
      err,
    };
  },

  DeleteBegin: () => {
    return {
      type: actions.DELETE_BEGIN,
    };
  },

  DeleteSuccess: (data) => {
    return {
      type: actions.DELETE_SUCCESS,
      data,
    };
  },

  DeleteErr: (err) => {
    return {
      type: actions.DELETE_ERR,
      err,
    };
  },

  SingleDataBegin: () => {
    return {
      type: actions.SINGLE_DATA_BEGIN,
    };
  },

  SingleDataSuccess: (data) => {
    return {
      type: actions.SINGLE_DATA_SUCCESS,
      data,
    };
  },

  SingleDataErr: (err) => {
    return {
      type: actions.SINGLE_DATA_ERR,
      err,
    };
  },
};

export default actions;
